module.exports = __webpack_public_path__ + "static/media/fte-thrive-program-thumbnail.66aa4dcf.png";